import { Alert } from '@calendly/alert'
import { Switch, Route } from 'react-router-dom'

import { Intercom } from './intercom'
import { MicrosoftAdminConsent } from './microsoft_admin_consent'
import { OauthPostRedirect } from './oauth_post_redirect'
import { ZoomAdminConsent } from './zoom_admin_consent'

export const Routes = () => (
  <>
    <Alert />
    <Switch>
      <Route
        path="/users/auth/azure2_admin_consent"
        component={MicrosoftAdminConsent}
      />
      <Route
        path="/users/auth/intercom"
        component={Intercom}
      />
      <Route
        path="/users/auth/zoom_admin_consent"
        component={ZoomAdminConsent}
      />
      <Route
        path="/users/auth/:redirectPath"
        component={OauthPostRedirect}
      />
    </Switch>
  </>
)
